<template>
  <layout name="Sidebar" extraClass="csv-history-layout">
    <VTableView
      :sidebar="{
        buttons,
        title: 'Import History',
        extraClass: 'import-history-layout-heading'
      }"
      :with-pagination="total && total > 25"
    >
      <template slot="search">
        <ContactsImportHistoryFilter></ContactsImportHistoryFilter>
      </template>

      <template slot="table">
        <ContactsCSVHistoryTable
          extraClass="csv-history-table"
        ></ContactsCSVHistoryTable>
      </template>

      <template slot="pagination">
        <ContactsImportHistoryPagination></ContactsImportHistoryPagination>
      </template>
    </VTableView>
  </layout>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";

import Layout from "@/layouts/Layout";
import VTableView from "@/views/VTableView";

// components
import ContactsCSVHistoryTable from "@/components/ContactsCSVHistoryTable";
import ContactsImportHistoryFilter from "@/components/ContactsImportHistoryFilter";
import ContactsImportHistoryPagination from "@/components/ContactsImportHistoryPagination";
import WithLoader from "@/components/WithLoader";

import withNavigate from "@/mixins/withNavigate";

import { getViewTemplateFormat } from "@/utils/util";

export default Vue.component("CSVHistory", {
  metaInfo: {
    title: "Import History"
  },

  components: {
    Layout,
    ContactsCSVHistoryTable,
    WithLoader,
    VTableView,
    ContactsImportHistoryPagination,
    ContactsImportHistoryFilter
  },

  mixins: [withNavigate],

  data() {
    return {
      buttons: [
        {
          key: "back-to-contacts",
          type: "secondary",
          label: "Back",
          size: "regular",
          onClickHandler: e => this.navigate("/contacts"),
          extraClass: "back-from-history"
        }
      ]
    };
  },

  computed: {
    ...mapGetters("importHistory", [
      "sorting",
      "isLoading",
      "csvHistoryList",
      "total"
    ])
  },

  methods: {
    ...mapActions("importHistory", ["fetchCsvHistory"])
  },

  created() {
    this.fetchCsvHistory();
  }
});
</script>

<style lang="scss">
.csv-history-table__wrapper {
  @media screen and (max-width: $mid-screen) {
    overflow: auto;
  }
}
</style>
